import React from 'react';
import '../css/Banner.css';
import Navbar from './Navbar';
import myLogo from '../img/logo.png';

function Banner() {
    return (
        <div className="banner" id='banner'>
                  <Navbar />
            <div className="banner__title">
                    <h1 className="animate__animated animate__bounce animate__infinite">Ilir Shala</h1>
            </div>
            <div className="banner__subtitle">
                <h3 className="animate__animated animate__bounceInLeft infinite">FRONT END DEVELOPER</h3>
                <h3 className="animate__animated animate__bounceInRight">JUNIOR SOFTWARE DEVELOPER</h3>
            </div>
            <div className="banner__logo">
                <img src={myLogo} alt=""/>
            </div>
        </div>
    )
}

export default Banner;
